export default "__VITE_ASSET__DExy1lzu__"